<template>
  <div class="w100 bg-w">
    <iframe class="iframe" :src="`/hall/aws/portal/r/w?cmd=CLIENT_DW_PORTAL&processGroupId=obj_23f6d2b471ef4f6783cfed853e6e8ddd&appId=com.awspaas.user.apps.flowhall&dwViewId=obj_c9d20367e9904d87bd517a391615b4ff&sid=${userToken}`"></iframe>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeProcess",
  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapState(["userToken"])
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.iframe {
  width: 100%;
  min-height: calc(100vh - 160px);
  padding: 20px;
  border: none;
}
</style>
